<article class="content-container">
  @if (site()) {
    <div>
      <h1>{{ site().title }} <i class="mdi mdi-close can-click text-smaller dim" title="Select site" (click)="clearSiteClick()"></i></h1>

      @if (isSelectingAsset()) {
        <table class="table table-hover">
          <thead>
            <tr>
              <th>Asset</th>
              <th>Gateway</th>
              <th>Type</th>
            </tr>
          </thead>
          <tbody>
            @for (asset of assets(); track asset.id) {
              <tr (click)="assetClick(asset)">
                <td>{{ asset.title }}</td>
                <td>
                  <span title="{{ asset.gateway_id }}">{{ asset.gatewayTitle }}</span>
                </td>
                <td>{{ asset.assetTypeTitle }}</td>
              </tr>
            }
          </tbody>
        </table>
        @if (isLoadingAssets()) {
          <i class="mdi mdi-loading mdi-spin-x2"></i>
        }
      } @else {
        @if (asset()) {
          <h2>{{ asset().title }} <i class="mdi mdi-close can-click text-smaller dim" title="Remove this asset" (click)="asset.set(null)"></i></h2>
          <div class="query-container">
            <app-setpoint-query [assets]="[asset()]" view="compact" [showValue]="false" (onDateChange)="chartChange($event)" />
          </div>

          <div class="flex">
            <div (click)="useRange = !useRange" class="can-click flex-1"><i class="mdi" title="Use this range for the asset in the issue" [class.mdi-checkbox-marked-outline]="useRange" [class.mdi-checkbox-blank-outline]="!useRange"></i> Use the range you select in the chart above</div>
            <div>
              @if (chartRange?.from && useRange) {
                <span title="Issue date range" tooltipPosition="left"><i class="mdi mdi-calendar-month"></i> {{ chartRange.from | date: 'dd/MM/yy' }} to {{ chartRange.to | date: 'dd/MM/yy' }}</span>
              } @else {
                <span>No date range applied to issue</span>
              }
            </div>
          </div>
        } @else {
          <h2><app-button label="Select an asset (optional)" (click)="selectAssetClick()" /></h2>
        }
      }
    </div>

    <form>
      <div>
        <label>Summary</label>
        <input class="fourd" type="text" placeholder="" [(ngModel)]="title" name="summary" />
      </div>

      <div>
        <label>Details</label>
        <textarea class="fourd" type="text" placeholder="" [(ngModel)]="details" name="details" rows="5"></textarea>
      </div>

      <section class="flex">
        <div class="flex-1">
          <label>RAG</label>
          <select class="fourd" [(ngModel)]="rag" name="rag">
            <option value="red">Red</option>
            <option value="amber">Amber</option>
            <option value="green">Green</option>
          </select>
        </div>

        <div class="flex-1">
          <label title="The status" tooltipPosition="top">{{ issueType }} Status</label>
          <select class="fourd" title="Issue Status" [(ngModel)]="substatus_id" name="progress">
            @for (option of statusOptions; track option.id) {
              <option [value]="option.id">{{ option.title }}</option>
            }
          </select>
        </div>
      </section>
    </form>
    <!--
		
    <section>
      <h2>Entities linked</h2>
      <table class="table">
        <thead>
          <tr>
            <th>Type</th>
            <th>Entity</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          @for (item of entities(); track $index) {
            <tr>
              <td>{{ item.type }}</td>
              <td>{{ item.obj?.title || item.obj?.name }}</td>
              <td class="right">
                @if (item.type === 'org') {
                  <app-button size="small" label="Create for this Org" (click)="useThisOrg(item.obj)" />
                }
                <app-button size="small" label="Remove" (click)="removeEntity(item)" />
              </td>
            </tr>
          }
        </tbody>
      </table>
    </section>
	-->
    <div class="text-right">
      @if (isSavingIssue()) {
        <app-button label="Saving..." icon="mdi mdi-loading mdi-spin-x2"></app-button>
      } @else {
        <app-button label="Save" icon="mdi mdi-check" (click)="save()"></app-button>
      }
    </div>
    <footer></footer>

    @switch (dialog()) {
      @case ('entities') {
        <app-dialog header="Entities for {{ org?.title }}" (onClose)="dialog.set(null)" [canScroll]="false">
          <app-issue-tracking-entity-picker [org]="org" [entities]="entities" (onChanged)="entitiesSelected($event)" />
        </app-dialog>
      }
    }
  } @else {
    @if (sites()) {
      <section>
        <h1>Select the site</h1>
        <table class="table table-hover">
          <thead>
            <tr>
              <th>Site</th>
            </tr>
          </thead>
          <tbody>
            @for (site of sites(); track site.id) {
              <tr (click)="siteClick(site)">
                <td>{{ site.title }}</td>
              </tr>
            }
          </tbody>
        </table>
      </section>
    } @else {
      <i class="mdi mdi-spin mdi-loading"></i>
    }
  }
</article>
